// extracted by mini-css-extract-plugin
export default {"carousel-active-logic":"KXfmq","active":"QTsnd","inactive":"q4Zd3"};